export default "__VITE_ASSET__cI6r$85e__"